// extracted by mini-css-extract-plugin
export var printerCard = "_aw-1";
export var printerCardConfigured = "_aw-2";
export var printerCardError = "_aw-3";
export var printerCardsContainer = "_aw-0";
export var printerIcon = "_aw-8";
export var printerIconConfigured = "_aw-5";
export var printerIconContainer = "_aw-4";
export var printerIconError = "_aw-6";
export var printerIconUnconfigured = "_aw-7";
export var workstationsTableCard = "_aw-9";